import AccordionBox from "../../../../../../components/AccordionBox";
import {
  RazorBadgeTwo,
  RazorButton,
  RazorDateTime,
  RazorImageFallback,
  RazorInputField,
} from "../../../../../../components/razor-reuse";
import ZoomableImage from "../../../../../../components/fragment/image/zoomable-image";
import { useOverviewContext } from "../../../CustomerSingle";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../../../redux/type";
import CustomModal, {
  useDialogToggle,
} from "../../../../../../components/fragment/custom-modal";
import { systemRoles } from "../../../../../../utils/roles";
import { useState } from "react";
import {
  addCommentToDocument,
  getCustomerAdditionalDoc,
  getCustomerSingle,
} from "../../../../../../redux/customer";
import {
  detectCloudinaryFileType,
  getDocumentPreviewUrl,
} from "../../../../../../utils/Helper";
import { groupBy } from "lodash";

export default function KycAccordTwo() {
  const dispatch = useDispatch();
  const context = useOverviewContext();
  const cust_id = localStorage?.getItem("cors_key") || "";
  const [comment, setcomment] = useState({
    content: "",
    name: "",
    id: "",
  });
  const { openDialog, closeDialog, dialogRef } = useDialogToggle();
  const {
    openDialog: openCreateDialog,
    closeDialog: closeCreateDialog,
    dialogRef: createRef,
  } = useDialogToggle();

  const { user } = useSelector((state: RootState) => state.auth);
  const { customer, creating_comment } = useSelector(
    (state: RootState) => state.customer,
  );

  const filteredPOA = customer?.documents?.filter(
    (vals: any) =>
      vals?.document_type === "UTILITY_BILL" || vals?.document_type === "POA",
  );

  const filteredSOF = customer?.documents?.filter(
    (vals: any) =>
      vals?.document_type === "FILE_ATTACHMENT" ||
      vals?.document_type === "BANK_STATEMENT" ||
      vals?.document_type === "PAY_SLIP" ||
      vals?.document_type === "TAX_RETURN" ||
      vals?.document_type === "INVESTMENT_CERTIFICATES" ||
      vals?.document_type === "CONTRACT_NOTES" ||
      vals?.document_type === "SIGNED_WILL" ||
      vals?.document_type === "GIFT_DECLARATION" ||
      vals?.document_type === "LOAN_AGREEMENT" ||
      vals?.document_type === "SIGNED_SALES_CONTRACT" ||
      vals?.document_type === "PROPERTY_OWNERSHIP_DOCUMENTS" ||
      vals?.document_type === "OTHERS" ||
      vals?.document_type === "SOF",
  );

  const newSof =
    filteredSOF?.filter(
      (chi: any) =>
        chi?.metadata?.newly_added === true || chi?.status === "approved",
    ) || [];

  const oldSof =
    filteredSOF?.filter(
      (chi: any) =>
        chi?.metadata?.newly_added === false && chi?.status !== "approved",
    ) || [];
  const oldSOFGrouped = groupBy(oldSof, (val: any) => val?.metadata?.group); // grouping doc according to how they entered
  const newSOFGrouped = groupBy(newSof, (val: any) => val?.metadata?.group); // grouping doc according to how they entered

  // console.log(oldSof, "oldSof", newSof, "newSof");

  const triggerAddComment = (id: string, name: string, content?: string) => {
    if (content) {
      openDialog();
      setcomment({
        content,
        name,
        id,
      });
    } else {
      openCreateDialog();
      setcomment({
        content: "",
        name,
        id,
      });
    }
  };
  const handleCreateComment = async () => {
    const data = await dispatch(
      addCommentToDocument({
        id: comment.id,
        body: { comment: comment.content },
      }) as any,
    );
    if (data?.payload?.data?.status) {
      closeCreateDialog();
      dispatch(getCustomerSingle({ id: cust_id }) as any);
      dispatch(getCustomerAdditionalDoc(cust_id) as any);
    }
  };

  return (
    <>
      <AccordionBox defaultState={false} title="KYC Level 2">
        <main className="bg-white min-h-[500px] p-[24px] space-y-[18px]">
          <div className="flex justify-between gap-x-[20px]">
            <h6 className="text-[16px] font-medium text-[#596080]">
              Individual Transaction: 2,000 Maximum
            </h6>
            <h6 className="text-[16px] font-medium text-[#596080]">
              Daily Limit: 5,000 Maximum
            </h6>
            <h6 className="text-[16px] font-medium text-[#596080]">
              Monthly Limit: 10,000 Maximum
            </h6>
          </div>
          {/* Proof of Address */}
          <div className="border border-[#e6e6e6] rounded-lg pb-[60px]">
            <div className="flex justify-between items-center border-[#e6e6e6] border-b py-[14px] px-[35px]">
              <p className="text-gray-01 text-[14px] font-medium">
                Proof of Address (POA)
              </p>
            </div>

            <div className=" mt-[8px]">
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-[30px] justify-around">
                {filteredPOA?.length === 0 ? (
                  <div className="space-y-[8px] mx-auto">
                    <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box">
                      <RazorImageFallback loadSize={45} url={" "}>
                        <figure className="size-full text-gray-02">
                          No file found
                        </figure>
                      </RazorImageFallback>
                    </div>
                    <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                      <p className="">No upload</p>
                      <p className="inline-flex items-center">
                        Date Uploaded: ---
                      </p>
                    </div>
                  </div>
                ) : (
                  filteredPOA?.map((item: any, idx: number) => (
                    <div key={idx} className="space-y-[8px] mx-auto">
                      {item?.metadata?.fileType === "pdf" ? (
                        <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center text-center overflow-hidden">
                          <a
                            href={item?.file_path?.[1]}
                            target="_blank"
                            className="text-gray-01 underline cursor-pointer"
                            rel="noreferrer"
                          >
                            <span className="text-gray-01 cursor-pointer ">
                              Click to preview
                            </span>
                            <br />
                            {item?.metadata?.fileName}
                          </a>
                        </div>
                      ) : (
                        <ZoomableImage
                          src={item?.file_path?.[1]}
                          alt={item?.document_type}
                          width={400}
                          height={450}
                          zoomLevel={1.3}
                          zoomWindowSize={400}
                          onClick={() => {
                            context?.setDocumentModal({
                              visible: true,
                              url: item?.file_path?.[1],
                              doc_name: item?.metadata?.fileName,
                              file_name: item?.document_type,
                              file_sizee: item?.metadata?.fileSize,
                              status: item?.status,
                              date: item?.updated_at,
                            });
                          }}
                          containerClassName="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box"
                        />
                      )}

                      <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                        <p className="">Current Upload</p>
                        <p className="inline-flex items-center">
                          Date Uploaded:{" "}
                          {
                            <RazorDateTime
                              date={item?.updated_at}
                              hideAgo
                              className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                            />
                          }
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* Source of Funds */}
          <div className="border border-[#e6e6e6] rounded-lg pb-[20px]">
            <div className="flex justify-between items-center border-[#e6e6e6] border-b py-[14px] px-[35px]">
              <p className="text-gray-01 text-[14px] font-medium">
                Source of Funds (SOF)
              </p>
              <p className="text-[12px] text-gray-02 flex items-center">
                Status:
                {filteredSOF?.length !== 0 ? (
                  <RazorBadgeTwo
                    className={`text-[14px] ml-[8px] !py-[4px] !px-[12px]
                     ${customer?.kyc?.sof_verified ? "success" : "failed"}`}
                    text={customer?.kyc?.sof_verification_status?.replace(
                      "_",
                      " ",
                    )}
                  />
                ) : (
                  "Non Uploaded"
                )}
              </p>
            </div>
            {filteredSOF?.length === 0 ? (
              <div className="space-y-[8px] mx-auto">
                <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box">
                  <RazorImageFallback loadSize={45} url={" "}>
                    <figure className="size-full text-gray-02">
                      No file found
                    </figure>
                  </RazorImageFallback>
                </div>
                <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                  <p className="">No upload</p>
                  <p className="inline-flex items-center">Date Uploaded: ---</p>
                </div>
              </div>
            ) : (
              <>
                {newSof?.length > 0 && (
                  <>
                    <div className="bg-pry px-[30px] py-[16px] mx-[20px] my-[22px] mt-[30px] rounded-2xl flex items-start justify-between text-white [&_h6]:text-[16px] [&_p]:text-[14px]">
                      <div>
                        <h6>
                          {customer?.kyc?.sof_verification_status !== "approved"
                            ? "Current"
                            : "Approved"}{" "}
                          Upload
                        </h6>
                        <p className="mt-[4px]">{newSof?.length} Documents</p>
                      </div>
                      <div>
                        <h6>Status</h6>
                        <p className="capitalize mt-[4px]">
                          {customer?.kyc?.sof_verification_status?.replace(
                            "_",
                            " ",
                          )}
                        </p>
                      </div>
                      <div>
                        <h6>Reason for Rejection</h6>
                        <p>None </p>
                      </div>
                    </div>

                    <div className="mt-[8px]">
                      <div className="grid grid-cols-2 xl:grid-cols-3 gap-[30px] justify-around">
                        {Object.entries(newSOFGrouped)
                          ?.reverse()
                          ?.map(([_, documents]) => (
                            <div className="border-pry/70 border-dashed border-[2px] mx-[4px] p-[16px] col-span-full grid grid-cols-2 xl:grid-cols-3 gap-[30px] justify-around">
                              {documents?.map((item: any, idx: number) => (
                                <div
                                  key={idx}
                                  className="space-y-[8px] mx-auto border px-[4px] pb-[4px] rounded-[8px]"
                                >
                                  {detectCloudinaryFileType(
                                    item?.file_path?.[1],
                                  ) !== "image" ||
                                  item?.metadata?.fileType === "pdf" ||
                                  item?.file_path?.[1]?.includes("/raw") ? (
                                    <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden text-center">
                                      <a
                                        href={getDocumentPreviewUrl(
                                          item?.file_path?.[1],
                                          detectCloudinaryFileType(
                                            item?.file_path?.[1],
                                          ) === "pdf" ||
                                            item?.metadata?.fileType === "pdf",
                                        )}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <span className="text-gray-01 underline cursor-pointer">
                                          Click to preview
                                        </span>

                                        <br />
                                        <span className="text-gray-01 underline cursor-pointer">
                                          {item?.metadata?.fileName ||
                                            item?.document_sub_type}
                                        </span>
                                      </a>
                                    </div>
                                  ) : (
                                    <ZoomableImage
                                      src={item?.file_path?.[1]}
                                      alt={item?.document_type}
                                      width={400}
                                      height={450}
                                      zoomLevel={1.3}
                                      zoomWindowSize={400}
                                      onClick={() => {
                                        context?.setDocumentModal({
                                          visible: true,
                                          url: item?.file_path?.[1],
                                          doc_name:
                                            item?.metadata?.document_name ||
                                            item?.metadata?.fileName,
                                          file_name: item?.document_type,
                                          file_sizee: item?.metadata?.fileSize,
                                          status: item?.status,
                                          date: item?.updated_at,
                                        });
                                      }}
                                      containerClassName="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box"
                                    />
                                  )}

                                  <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                                    <p className="">Current Upload</p>
                                    <p className="inline-flex items-center">
                                      Date Uploaded:{" "}
                                      {
                                        <RazorDateTime
                                          date={item?.updated_at}
                                          hideAgo
                                          className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                                        />
                                      }
                                    </p>
                                    {item?.comments?.rejection_reason?.length >
                                      0 && (
                                      <div className="group cursor-pointer w-full">
                                        <p className="">Rejection Reason</p>
                                        <div className="px-[8px] py-[10px] rounded-[8px] bg-[#cc09051a] text-[#cc0905]">
                                          <p className="line-clamp-1 group-hover:line-clamp-none ease-linear transition-all duration-1000">
                                            {item?.comments?.rejection_reason}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    <button
                                      onClick={() => {
                                        triggerAddComment(
                                          item?.id,
                                          item?.document_sub_type,
                                          item?.comments?.comments?.[0]?.text,
                                        );
                                      }}
                                      className="text-[12px] text-primary border border-primary py-[6px] px-[18px] rounded-[8px] block mx-auto"
                                    >
                                      {item?.comments?.comments?.length > 0
                                        ? "View"
                                        : "Add"}{" "}
                                      Comment
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                      </div>
                      {/* approve/reject */}
                      {user?.permissions?.includes(systemRoles[4]) &&
                        filteredSOF?.length !== 0 &&
                        !customer?.kyc?.sof_verified &&
                        customer?.kyc?.sof_verification_status !==
                          "approved" && (
                          <div className="flex justify-between items-center gap-x-[20px] mt-[20px] px-[20px]">
                            <div className="col-span-full space-x-[30px] [&_button]:h-[32px] [&_button]:w-[78px] [&_button]:border-[1.5px] [&_button]:rounded-[6px] *:text-[14px] *:font-medium">
                              {user?.permissions?.includes(systemRoles[5]) && (
                                <button
                                  onClick={() => {
                                    context?.setKycStatus({
                                      visible: true,
                                      status: "approve",
                                      reason: "",
                                    });
                                  }}
                                  className="border-green-01 text-green-01 bg-green-02"
                                >
                                  Approve
                                </button>
                              )}
                              {user?.permissions?.includes(systemRoles[6]) && (
                                <button
                                  onClick={() => {
                                    context?.setKycStatus({
                                      visible: true,
                                      status: "reject",
                                      reason: "",
                                    });
                                  }}
                                  className="text-red-01 border-red-01 bg-red-02"
                                >
                                  Reject
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </>
                )}
                <>
                  <div className="bg-pry px-[30px] py-[16px] mx-[20px] my-[22px] mt-[30px] rounded-2xl flex items-start justify-between text-white [&_h6]:text-[16px] [&_p]:text-[14px]">
                    <div>
                      <h6>Rejected Upload</h6>
                      <p className="mt-[4px]">{oldSof?.length} Documents</p>
                    </div>
                    <div>
                      <h6>Reason for Rejection</h6>
                      <p>
                        {customer?.address_verification_reason ? (
                          <button
                            onClick={() => {
                              openDialog();
                              setcomment({
                                content: customer?.address_verification_reason,
                                name: "",
                                id: "",
                              });
                            }}
                            disabled={!customer?.address_verification_reason}
                            className="text-[12px] text-primary border bg-white py-[4px] px-[10px] rounded-[8px] mt-[2px]"
                          >
                            View Reason for Rejection
                          </button>
                        ) : (
                          "None"
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="mt-[8px]">
                    <div className="grid grid-cols-2 xl:grid-cols-3 gap-[30px] justify-around">
                      {oldSof?.length < 1 ? (
                        <div className="space-y-[8px] mx-auto">
                          <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box">
                            <RazorImageFallback loadSize={45} url={" "}>
                              <figure className="size-full text-gray-02">
                                No file found
                              </figure>
                            </RazorImageFallback>
                          </div>
                        </div>
                      ) : (
                        Object.entries(oldSOFGrouped)
                          ?.reverse()
                          ?.map(([_, documents]) => (
                            <div className="border-pry/70 border-dashed border-[2px] mx-[4px] p-[16px] col-span-full grid grid-cols-2 xl:grid-cols-3 gap-[30px] justify-around">
                              {documents?.map((item: any, idx: number) => (
                                <div
                                  key={idx}
                                  className="space-y-[8px] mx-auto border px-[4px] pb-[4px] rounded-[8px]"
                                >
                                  {detectCloudinaryFileType(
                                    item?.file_path?.[1],
                                  ) !== "image" ||
                                  item?.metadata?.fileType === "pdf" ||
                                  item?.file_path?.[1]?.includes("/raw") ? (
                                    <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden text-center">
                                      <a
                                        href={getDocumentPreviewUrl(
                                          item?.file_path?.[1],
                                          detectCloudinaryFileType(
                                            item?.file_path?.[1],
                                          ) === "pdf" ||
                                            item?.metadata?.fileType === "pdf",
                                        )}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <span className="text-gray-01 underline cursor-pointer">
                                          Click to preview
                                        </span>

                                        <br />
                                        <span className="text-gray-01 underline cursor-pointer">
                                          {item?.metadata?.fileName ||
                                            item?.document_sub_type}
                                        </span>
                                      </a>
                                    </div>
                                  ) : (
                                    <ZoomableImage
                                      src={item?.file_path?.[1]}
                                      alt={item?.document_type}
                                      width={400}
                                      height={450}
                                      zoomLevel={1.3}
                                      zoomWindowSize={400}
                                      onClick={() => {
                                        context?.setDocumentModal({
                                          visible: true,
                                          url: item?.file_path?.[1],
                                          doc_name: item?.metadata?.fileName,
                                          file_name: item?.document_type,
                                          file_sizee: item?.metadata?.fileSize,
                                          status: item?.status,
                                          date: item?.updated_at,
                                        });
                                      }}
                                      containerClassName="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box"
                                    />
                                  )}

                                  <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                                    <p className="">Last Upload</p>

                                    <p className="inline-flex items-center">
                                      Date Uploaded:{" "}
                                      {
                                        <RazorDateTime
                                          date={item?.updated_at}
                                          hideAgo
                                          className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                                        />
                                      }
                                    </p>
                                    {item?.comments?.rejection_reason?.length >
                                      0 && (
                                      <div className="group cursor-pointer w-full">
                                        <p className="">Rejection Reason</p>
                                        <div className="px-[8px] py-[10px] rounded-[8px] bg-[#cc09051a] text-[#cc0905]">
                                          <p className="line-clamp-1 group-hover:line-clamp-none ease-linear transition-all duration-1000">
                                            {item?.comments?.rejection_reason}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    <button
                                      onClick={() => {
                                        triggerAddComment(
                                          item?.id,
                                          item?.document_sub_type,
                                          item?.comments?.comments?.[0]?.text,
                                        );
                                      }}
                                      className="text-[12px] text-primary border border-primary py-[6px] px-[18px] rounded-[8px] block mx-auto"
                                    >
                                      {item?.comments?.comments?.length > 0
                                        ? "View"
                                        : "Add"}{" "}
                                      Comment
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))
                      )}
                    </div>
                    {/* approve/reject */}
                    {user?.permissions?.includes(systemRoles[4]) &&
                      filteredSOF?.length !== 0 &&
                      !customer?.kyc?.sof_verified &&
                      customer?.kyc?.sof_verification_status !== "approved" &&
                      newSof?.length < 1 && (
                        <div className="flex justify-between items-center gap-x-[20px] mt-[20px] px-[20px]">
                          <div className="col-span-full space-x-[30px] [&_button]:h-[32px] [&_button]:w-[78px] [&_button]:border-[1.5px] [&_button]:rounded-[6px] *:text-[14px] *:font-medium">
                            {user?.permissions?.includes(systemRoles[5]) && (
                              <button
                                onClick={() => {
                                  context?.setKycStatus({
                                    visible: true,
                                    status: "approve",
                                    reason: "",
                                  });
                                }}
                                className="border-green-01 text-green-01 bg-green-02"
                              >
                                Approve
                              </button>
                            )}
                            {user?.permissions?.includes(systemRoles[6]) &&
                              customer?.kyc?.sof_verification_status?.toLowerCase() !==
                                "rejected" && (
                                <button
                                  onClick={() => {
                                    context?.setKycStatus({
                                      visible: true,
                                      status: "reject",
                                      reason: "",
                                    });
                                  }}
                                  className="text-red-01 border-red-01 bg-red-02"
                                >
                                  Reject
                                </button>
                              )}
                          </div>
                        </div>
                      )}
                  </div>
                </>
              </>
            )}
          </div>
        </main>
        <CustomModal
          ref={dialogRef}
          onClose={() => {
            closeDialog();
            setcomment({
              content: "",
              name: "",
              id: "",
            });
          }}
          headerTitle="View Comment"
          containerClass="!w-[460px]"
        >
          <section className="mx-[28px] my-[24px] p-[10px] text-[14px] bg-white min-h-[78px] text-[#758089]">
            * {comment.content}
          </section>
        </CustomModal>

        {/* create comment */}
        <CustomModal
          ref={createRef}
          onClose={() => {
            closeCreateDialog();
            setcomment({
              content: "",
              name: "",
              id: "",
            });
          }}
          headerTitle="Add Comment"
          containerClass="!w-[460px]"
        >
          <section className="mx-[18px] my-[24px] p-[10px] text-[14px] min-h-[78px] text-[#758089]">
            <p className="text-[16px]">
              Add remarks for : {comment.name || "document file"}
            </p>
            <RazorInputField
              color="black-light"
              className="mt-[10px] "
              selectClassName={"!bg-red-200"}
              textareaRow={3}
              type="textarea"
              placeholder="Enter Comment"
              disabled={false}
              onChange={(e: any) => {
                const { value, name } = e.target;
                setcomment((prev) => ({ ...prev, [name]: value }));
              }}
              name="content"
              value={comment.content}
              capitalize
            />

            <div className="flex items-center gap-[6px] mt-[14px]">
              <RazorButton
                className="btn btn-big"
                label="Add Comment"
                color="black-light"
                onClick={handleCreateComment}
                disabled={creating_comment}
                loading={creating_comment}
              />
            </div>
          </section>
        </CustomModal>
      </AccordionBox>
    </>
  );
}
